import { State_update, Types_Msg$4, State_init } from "../ThreeDocs.Client.StateMachine.Crud/CrudComponent.js";
import { CustomShared_get_currentRoles_, PracticesUpdateArgs, CustomShared, PracticesCrudConfig_practiceVmModelConfig, PracticesCrudConfig_practiceVmViewConfig, PracticesCrudConfig_generalViewLayoutConfig } from "./PracticesCrudConfig.js";
import { ofArray, singleton, empty } from "../fable_modules/fable-library-js.4.25.0/List.js";
import { Msg, Model } from "./PracticesTypes.js";
import { Cmd_batch, Cmd_none, Cmd_map } from "../fable_modules/Fable.Elmish.4.4.0/cmd.fs.js";
import { Permission, isAllowed } from "../ThreeDocs.Models/Security.js";
import { Cmd_OfAsyncWith_either } from "../fable_modules/Fable.Elmish.4.4.0/cmd.fs.js";
import { AsyncHelpers_start } from "../fable_modules/Fable.Elmish.4.4.0/prelude.fs.js";
import { securedApi } from "../Api.js";
import { error } from "../ThreeDocs.SharedUI/Toast.js";
import { ErrorMessage_get_describe } from "../ThreeDocs.Models/Api/Api.js";
import { Shared_CrudInbound$2 } from "../ThreeDocs.Client.StateMachine.Crud/SharedCrud.js";
import { printf, toText } from "../fable_modules/fable-library-js.4.25.0/String.js";
import { some } from "../fable_modules/fable-library-js.4.25.0/Option.js";
import { Navigation_newUrl } from "../fable_modules/Fable.Elmish.Browser.4.1.0/navigation.fs.js";
import { Page, pageHash } from "../Pages.js";
import { Optic_Set, Optic_Set_op_HatEquals_2170E4F5 } from "../fable_modules/Fable.Aether.1.0.2/Aether.fs.js";

export function init() {
    const patternInput = State_init(PracticesCrudConfig_generalViewLayoutConfig(PracticesCrudConfig_practiceVmViewConfig.viewListItemConfig.listColumns, PracticesCrudConfig_practiceVmModelConfig.isSameItem), PracticesCrudConfig_practiceVmViewConfig, PracticesCrudConfig_practiceVmModelConfig, new CustomShared(empty()));
    return [new Model(patternInput[0]), Cmd_map((Item) => (new Msg(5, [Item])), patternInput[1])];
}

export function update(token, userInfo, msg, model) {
    let msg_2;
    switch (msg.tag) {
        case 2:
            if (isAllowed(new Permission(10, []))(userInfo.roles)) {
                return [model, Cmd_OfAsyncWith_either((x) => {
                    AsyncHelpers_start(x);
                }, securedApi(token).getPractices, undefined, (Item_3) => (new Msg(3, [Item_3])), (Item_4) => (new Msg(0, [Item_4])))];
            }
            else {
                return [model, Cmd_none()];
            }
        case 3:
            if (msg.fields[0].tag === 1) {
                return [model, error(ErrorMessage_get_describe()(msg.fields[0].fields[0]))];
            }
            else {
                return [model, singleton((dispatch_2) => {
                    dispatch_2(new Msg(5, [new Types_Msg$4(2, [new Shared_CrudInbound$2(0, [msg.fields[0].fields[0]])])]));
                })];
            }
        case 4:
            if (msg.fields[0].tag === 1) {
                return [model, singleton((dispatch_3) => {
                    dispatch_3(new Msg(2, []));
                })];
            }
            else {
                return [model, Cmd_none()];
            }
        case 0: {
            console.error(some(toText(printf("Error: %O"))(msg.fields[0])));
            return [model, Cmd_none()];
        }
        case 5:
            if (msg.fields[0].tag === 1) {
                switch (msg.fields[0].fields[0].tag) {
                    case 1:
                        return [model, error("An unexpected error occurred. Please try again.")];
                    case 2:
                        return [model, Navigation_newUrl(pageHash(new Page(6, [msg.fields[0].fields[0].fields[0]])))];
                    case 3:
                        return [model, Navigation_newUrl(pageHash(new Page(8, [msg.fields[0].fields[0].fields[0]])))];
                    default:
                        return [model, error(ErrorMessage_get_describe()(msg.fields[0].fields[0].fields[0]))];
                }
            }
            else {
                const patternInput = State_update(new PracticesUpdateArgs(token), msg.fields[0], model.PracticeCrudModel);
                return [new Model(patternInput[0]), Cmd_map((Item_8) => (new Msg(5, [Item_8])), patternInput[1])];
            }
        default:
            return [model, Cmd_batch(ofArray([singleton((dispatch) => {
                dispatch(new Msg(2, []));
            }), (msg_2 = (new Msg(5, [new Types_Msg$4(2, [new Shared_CrudInbound$2(4, [Optic_Set_op_HatEquals_2170E4F5(new Optic_Set(), CustomShared_get_currentRoles_())(userInfo.roles)])])])), singleton((dispatch_1) => {
                dispatch_1(msg_2);
            }))]))];
    }
}

